import React from 'react'
import Helmet from 'react-helmet'
import { Link, graphql } from 'gatsby'
import Layout from '../components/Layout'
import Img from 'gatsby-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons'

class TagRoute extends React.Component {
  render() {
    const posts = this.props.data.allMarkdownRemark.edges
    const postLinks = posts.map(post => (
      <li key={post.node.fields.slug}>
        <Link to={post.node.fields.slug}>
          <h2 className="is-size-2">{post.node.frontmatter.title}</h2>
        </Link>
      </li>
    ))
    const postCards = posts.map( ({ node: post }) => (
              <div className="news-preview-item" key={post.id}>
              <Img sizes={post.frontmatter.thumbnail.childImageSharp.sizes} alt="" style={{height: '154px', borderTopLeftRadius: '5px', borderTopRightRadius: '5px'}} />
              <div className="news-preview-content">
              <p className="is-size-5">{post.frontmatter.title}<br /><small className="accent-color">{post.frontmatter.date}</small></p>
              </div>
              <div className="news-preview-footer">
                {
                    (post.frontmatter.externalLink === null) ? (
                      < >
                      <Link className="button is-white" to={post.fields.slug}>Read More</Link>
                      <div class="dropdown is-hoverable is-up">
                      <div class="dropdown-trigger">
                        <button class="button is-white" aria-haspopup="true" aria-controls="dropdown-menu4">
                          <span>Share</span>
                          <span className="icon is-small">
                          <FontAwesomeIcon icon={faAngleUp} />
                          </span>
                        </button>
                      </div>
                      <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                        <div class="dropdown-content">
                          <a target="_blank" rel="noreferrer noopener" href={'http://www.twitter.com/share?url=https://gifted-lewin-c829e3.netlify.com'+post.fields.slug} className="dropdown-item">
                            <span className="icon">
                            <FontAwesomeIcon icon={faTwitter} />
                            </span>
                            Twitter
                          </a>
                          <hr class="dropdown-divider" />
                          <a target="_blank" rel="noreferrer noopener" href={'https://www.facebook.com/sharer/sharer.php?u=https://gifted-lewin-c829e3.netlify.com'+post.fields.slug} className="dropdown-item">
                            <span className="icon">
                            <FontAwesomeIcon icon={faFacebookF} />
                            </span>
                            Facebook
                          </a>
                        </div>
                      </div>
                    </div> 
                    </ >
                    ) : (
                      < >
                      <a target="_blank" rel="noopener noreferrer" href={post.frontmatter.externalLink} className="button is-white">Read More</a>
                      <div class="dropdown is-hoverable is-up">
                  <div class="dropdown-trigger">
                    <button class="button is-white" aria-haspopup="true" aria-controls="dropdown-menu4">
                      <span>Share</span>
                      <span className="icon is-small">
                      <FontAwesomeIcon icon={faAngleUp} />
                      </span>
                    </button>
                  </div>
                  <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                    <div class="dropdown-content">
                      <a target="_blank" rel="noreferrer noopener" href={'http://www.twitter.com/share?url='+post.frontmatter.externalLink} className="dropdown-item">
                        <span className="icon">
                        <FontAwesomeIcon icon={faTwitter} />
                        </span>
                        Twitter
                      </a>
                      <hr class="dropdown-divider" />
                      <a target="_blank" rel="noreferrer noopener" href={'https://www.facebook.com/sharer/sharer.php?u='+post.frontmatter.externalLink} className="dropdown-item">
                        <span className="icon">
                        <FontAwesomeIcon icon={faFacebookF} />
                        </span>
                        Facebook
                      </a>
                    </div>
                  </div>
                </div>
                </ >
                    )
                }
              </div>
            </div>

            ))
            




    const tag = this.props.pageContext.tag
    const title = this.props.data.site.siteMetadata.title
    const totalCount = this.props.data.allMarkdownRemark.totalCount
    const tagHeader = `${totalCount} post${
      totalCount === 1 ? '' : 's'
    } tagged with “${tag}”`

    return (
      <Layout>
        <section className="section">
          <Helmet title={`${tag} | ${title}`} />
          <div className="container content">
            <div className="columns">
              <div
                className="column is-10 is-offset-1"
                style={{ marginBottom: '6rem' }}
              >
                <h3 className="title is-size-3 is-bold-light">{tagHeader}</h3>
                <p> <Link to="/tags/">Browse all tags</Link> </p>

                <div className="section">
                  <div className="news-preview-container">{postCards}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default TagRoute

export const tagPageQuery = graphql`
  query TagPage($tag: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            description
            externalLink
            thumbnail {
              childImageSharp {
                sizes (maxWidth: 400){
                  ...GatsbyImageSharpSizes_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`
